import { authConfig } from '@/features/auth/config.ts';
import { ReactNode } from 'react';
import { AuthContext, AuthContextValue } from './AuthContext';
import { useSuspenseQuery } from '@tanstack/react-query';
import { userQueries } from '@/features/auth/queries.ts';

interface AuthProviderProps {
  children?: ReactNode;
}

export const AuthProvider = ({ children }: AuthProviderProps) => {
  const { data: currentUser } = useSuspenseQuery(userQueries.getCurrentUser());

  const logout = () => {
    window.location.replace(
      `${authConfig.urls.LOGOUT}?redirectUri=${encodeURIComponent(window.location.href)}`
    );
  };

  const contextValue: AuthContextValue = {
    logout,
    currentUser,
  };

  return <AuthContext.Provider value={contextValue}>{children}</AuthContext.Provider>;
};
